import { readJsonObject, STORAGE_KEYS, storage, writeJson } from './store';

/**
 * Three states. `unset` = never asked (production's `null`); a stored value other than
 * "granted"/"denied" is treated as unset, which is how production's boot and track() behaved.
 */
export type ConsentState = 'granted' | 'denied' | 'unset';

/** Stored as `m618_consent_v1` = {"state":"granted"|"denied","ts":<ms>,"v":1} — shared with the static pages. */
export interface StoredConsent {
  readonly state: 'granted' | 'denied';
  readonly ts: number;
  readonly v: 1;
}

export function readConsent(): ConsentState {
  const stored = readJsonObject(STORAGE_KEYS.consent);
  const state = stored?.state;
  return state === 'granted' || state === 'denied' ? state : 'unset';
}

export function writeConsent(state: 'granted' | 'denied', now: number): void {
  const record: StoredConsent = { state, ts: now, v: 1 };
  writeJson(STORAGE_KEYS.consent, record);
}

export function clearConsent(): void {
  storage.remove(STORAGE_KEYS.consent);
}
